import { sendCrossTabEvent } from '@sironamedical/common/utils/sendCrossTabEvent';
import { NameSpaces } from 'modules/EventsManager';

/** Notify other windows to rehydrate user settings */

export const notifyUserSettingsUpdate = () => {
  sendCrossTabEvent(NameSpaces.CROSS_WINDOW_DATA_REFETCH, {
    type: 'user',
  });
};
